import React from 'react'
import type {
  DashboardMetricItemData,
  DashboardMetricFooterTrend,
} from '../types/dashboardMetrics.types'

export type { DashboardMetricItemData, DashboardMetricFooterTrend }

function buildMetricFooter(
  footerText?: string,
  trend?: DashboardMetricFooterTrend,
): React.ReactNode | undefined {
  if (footerText == null && trend == null) return undefined
  if (footerText == null) return undefined
  const icon =
    trend === 'up' ? (
      <i className="mgc mgc_arrow_up_circle_fill" aria-hidden />
    ) : trend === 'down' ? (
      <i className="mgc mgc_arrow_down_circle_fill" aria-hidden />
    ) : null
  return (
    <>
      {icon}
      {icon != null ? ' ' : null}
      {footerText}
    </>
  )
}

export function metricDataToItemProps(data: DashboardMetricItemData): {
  leftLabel: string
  rightLabel?: string
  value: React.ReactNode
  valueOver?: React.ReactNode
  footer?: React.ReactNode
  infoTooltip?: string
  showInfoIcon?: boolean
  showWarningIcon?: boolean
  className?: string
} {
  const toneClass =
    data.valueTone === 'danger' ? 'dashboard-metric-item--value-danger' : ''
  const footerClass =
    data.footerTrend === 'down' ? 'dashboard-metric-item--footer-down' : ''
  const className = [data.className, toneClass, footerClass]
    .filter(Boolean)
    .join(' ')

  return {
    leftLabel: data.leftLabel,
    rightLabel: data.rightLabel,
    value: data.value,
    valueOver: data.valueOver,
    footer: buildMetricFooter(data.footer, data.footerTrend),
    infoTooltip: data.infoTooltip,
    showInfoIcon: data.showInfoIcon,
    showWarningIcon: data.showWarningIcon,
    className: className || undefined,
  }
}

export type DashboardMetricItemProps = ReturnType<typeof metricDataToItemProps>

/** Merges layout class (e.g. bordered tile) after metric props so spread order cannot drop it. */
export function metricDataToItemPropsWithLayoutClass(
  data: DashboardMetricItemData,
  layoutClassName: string,
): DashboardMetricItemProps {
  const props = metricDataToItemProps(data)
  const merged = [layoutClassName, props.className].filter(Boolean).join(' ')
  return {
    ...props,
    className: merged || undefined,
  }
}
